import React, { useEffect, useState, useCallback, useContext } from "react";
import api, { BASE_URL } from "../../Utils/api";
import TiposAgendamentoModal from "./TiposAgendamentoModal";
import UsuariosNotificacaoModal from "./UsuariosNotificacaoModal";
import GridPadrao from "../GridPadrao/GridPadrao";
import { Modal, Table, Button, Badge } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { FaUsers, FaUserFriends } from "react-icons/fa";
import { getDescricaoPeriodicidade } from "../../Utils/dadosAgendamento";
import { GlobalContext } from "../../Utils/GlobalContext";
import PageHeader from "../PageHeader/PageHeader";
import { useFeedback } from "../Generals/Feedback/FeedbackContext";


function TiposAgendamento() {
  const { toast, confirm } = useFeedback();
  const [tiposAgendamento, setTiposAgendamento] = useState([]);
  const [selectedAgendamento, setSelectedAgendamento] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [usuariosNotificacao, setUsuariosNotificacao] = useState({});
  const [modalUsuarios, setModalUsuarios] = useState([]);
  const [showUsuariosModal, setShowUsuariosModal] = useState(false);
  const [agendamentoParaUsuarios, setAgendamentoParaUsuarios] = useState(null);
  const [showAcaoUsuariosModal, setShowAcaoUsuariosModal] = useState(false);

  const token = localStorage.getItem("authToken");
  const { globalData } = useContext(GlobalContext);
  const entidadeID = globalData?.entidade_id || localStorage.getItem("entidade_id");
  const permiteEdicao = "S";

  const handleOpenUsuarios = (agendamentoId) => {
    setModalUsuarios(usuariosNotificacao[agendamentoId] || []);
    setShowUsuariosModal(true);
  };

  const columns = [
    { Header: "Nome",      accessor: "nome" },
    { Header: "Descrição", accessor: "descricao" },
    {
      Header: "Periodicidade",
      accessor: "periodicidade",
      Cell: ({ row }) => (
        <Badge bg="secondary" pill>
          {getDescricaoPeriodicidade(row.periodicidade || "—")}
        </Badge>
      ),
    },
    {
      Header: "Usuários Notificação",
      accessor: "id",
      hideFilter: true,
      Cell: ({ row }) => {
        const agendamentoId = row.id;
        return (
          <div
            className="usuarios-badge"
            onClick={() => handleOpenUsuarios(agendamentoId)}
            title="Clique para ver usuários de notificação"
            role="button"
          >
            <FaUsers size={14} style={{ color: "var(--accent)" }} />
          </div>
        );
      },
    },
    { Header: "Situação", accessor: "situacao" },
  ];

  const fetchUsuariosNotificacao = useCallback(async (agendamentos) => {
    const usuariosTemp = {};

    await Promise.all(
      agendamentos.map((agendamento) =>
        api
          .get(
            `${BASE_URL}/api/tiposAgendamentos/ListarUsuariosNotificacaoPorTipoAgendamento/${agendamento.id}`,
            { headers: { Authorization: `Bearer ${token}` } }
          )
          .then((res) => {
            usuariosTemp[agendamento.id] = res.data.data;
          })
          .catch((err) => {
            console.error(`Erro ao buscar usuários para o agendamento ${agendamento.id}:`, err);
            usuariosTemp[agendamento.id] = [];
          })
      )
    );

    setUsuariosNotificacao(usuariosTemp);
  }, [token]);

  const fetchTiposAgendamento = useCallback(() => {
    if (!entidadeID) return;

    api
      .get(`${BASE_URL}/api/tiposAgendamentos/ListarTiposAgendamento/${entidadeID}`, {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then((response) => {
        setTiposAgendamento(response.data.data);
        fetchUsuariosNotificacao(response.data.data);
      })
      .catch((error) => {
        console.error("Erro ao buscar os tipos de agendamento:", error);
      });
  }, [token, entidadeID, fetchUsuariosNotificacao]);

  useEffect(() => {
    fetchTiposAgendamento();
  }, [fetchTiposAgendamento]);

  const handleEdit = (agendamento) => {
    setSelectedAgendamento(agendamento);
    setShowModal(true);
  };

  const handleAdd = () => {
    setSelectedAgendamento(null);
    setShowModal(true);
  };

  const handleClose = () => {
    setShowModal(false);
    setSelectedAgendamento(null);
  };

  // Ação "Usuários para Notificação" direto na grid — mesmo modal usado
  // dentro de TiposAgendamentoModal, aberto sozinho (sem o formulário de
  // edição por baixo), à esquerda de Excluir.
  const handleAcaoUsuariosNotificacao = (agendamento) => {
    setAgendamentoParaUsuarios(agendamento.id);
    setShowAcaoUsuariosModal(true);
  };

  const handleCloseAcaoUsuarios = () => {
    setShowAcaoUsuariosModal(false);
    fetchTiposAgendamento();
  };

  const handleExcluir = async (agendamento) => {
    const ok = await confirm(`Tem certeza que deseja excluir "${agendamento.nome}"?`);
    if (ok) {
      try {
        await api.delete(
          `${BASE_URL}/api/tiposAgendamentos/ExcluirTiposAgendamento/${agendamento.id}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        fetchTiposAgendamento();
      } catch (error) {
        console.error("Erro ao excluir tipo de agendamento:", error);
        toast.error(error.response?.data?.message || "Erro ao excluir. Tente novamente.");
      }
    }
  };

  return (
    <div>
      <PageHeader titulo="Cadastro de Tipos de Agendamento" path="/TiposAgendamento" />

      <GridPadrao
        columns={columns}
        data={tiposAgendamento}
        onEdit={(configuracao) => handleEdit(configuracao, permiteEdicao)}
        onAdd={handleAdd}
        onAcao={handleAcaoUsuariosNotificacao}
        acaoTitulo="Usuários para Notificação"
        acaoDataTour="tipos-agendamento-usuarios-notificacao"
        AcaoIcone={FaUserFriends}
        acaoVariant="light"
        onInactivate={handleExcluir}
      />

      <TiposAgendamentoModal
        show={showModal}
        handleClose={handleClose}
        agendamento={selectedAgendamento}
        fetchTiposAgendamento={fetchTiposAgendamento}
      />

      <UsuariosNotificacaoModal
        show={showAcaoUsuariosModal}
        handleClose={handleCloseAcaoUsuarios}
        agendamentoId={agendamentoParaUsuarios}
      />

      {/* Modal de Usuários Notificação */}
      <Modal
        show={showUsuariosModal}
        onHide={() => setShowUsuariosModal(false)}
        scrollable
        size="lg"
        dialogClassName="modal-dialog-top"
      >
        <Modal.Header closeButton style={{ background: "var(--surface-sunken)", borderColor: "var(--border-default)", paddingBottom: 12 }}>
          <Modal.Title style={{ fontSize: "1rem", fontWeight: 600, color: "var(--text-body)", display: "flex", alignItems: "center", gap: 8 }}>
            <FaUsers size={16} style={{ color: "var(--accent)" }} />
            Usuários de Notificação
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ background: "var(--surface-card)", color: "var(--text-body)" }}>
          <Table hover responsive size="sm" className="align-middle mb-0">
            <thead>
              <tr>
                <th style={{ fontSize: "var(--text-xs)", textTransform: "uppercase", letterSpacing: "var(--tracking-caps)", color: "var(--table-head-text)", fontWeight: 700, borderTop: "none" }}>Nome</th>
                <th style={{ fontSize: "var(--text-xs)", textTransform: "uppercase", letterSpacing: "var(--tracking-caps)", color: "var(--table-head-text)", fontWeight: 700, borderTop: "none" }}>Email</th>
              </tr>
            </thead>
            <tbody>
              {modalUsuarios.length > 0 ? modalUsuarios.map((user, idx) => (
                <tr key={idx}>
                  <td>{user.nome}</td>
                  <td>{user.email}</td>
                </tr>
              )) : (
                <tr><td colSpan={2}>Nenhum usuário encontrado</td></tr>
              )}
            </tbody>
          </Table>
        </Modal.Body>
        <Modal.Footer className="modal-footer-padrao">
          <div className="modal-footer-acoes-esquerda" />
          <div className="modal-footer-acoes-direita">
            <Button variant="light" className="modal-footer-btn-cancelar" onClick={() => setShowUsuariosModal(false)}>
              Fechar
            </Button>
          </div>
        </Modal.Footer>
      </Modal>

      <style>{`
        .usuarios-badge {
          display: inline-flex;
          align-items: center;
          gap: 0.3rem;
          cursor: pointer;
        }
      `}</style>
    </div>
  );
}

export default TiposAgendamento;
